import React from "react";
import GoogleButton from "react-google-button";
import { API_URL } from "../../redux/constants/type";
import { axiosInstance } from "../../redux/constants/axiosInstance";

const getGoogleReturnUrl = () => {
  const returnUrl = new URL(
    `${window.location.pathname}${window.location.search}`,
    window.location.origin,
  );

  returnUrl.searchParams.delete("status");
  returnUrl.searchParams.delete("provider");
  return returnUrl.toString();
};

const GoogleAuthButton = () => {
  const googleLogin = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_URL}/api/Integration/Google/Connect`,
        {
          params: { ReturnUrl: getGoogleReturnUrl() },
        },
      );

      const redirectUrl =
        response?.data?.data?.authorizationUrl ||
        response?.data?.authorizationUrl ||
        (typeof response?.data === "string" ? response.data : "");

      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    } catch (error) {
      console.error("Google connect failed:", error);
    }
  };

  return <GoogleButton onClick={googleLogin} label="Sync emails" />;
};

export default GoogleAuthButton;
